<template>
    <div class="container-fluid">
        <div class="card mb-2 mt-2">
            <div class="card-header">
                <h3>{{lang.LBL_AUDIT_LOG}}</h3>
            </div>
            <div class="card-body">
               
                <div class="table_responsive">
                    <table class="table m-0 item_table">
                        <thead>
                            <tr>
                                <th>Field</th>
                                <th>Old Value</th>
                                <th>New Value</th>
                                <th>Changed By</th>
                                <th>Change Date</th>
                                <th>Reason</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Date Of Birth</td>
                                <td></td>
                                <td>14/01/1868</td>
                                <td>admin.ether</td>
                                <td>14/04/2023 02:18pm</td>
                                <td></td>

                            </tr>
                        </tbody>
                    </table>
                </div>
               
            </div>
        </div>
    </div>
</template>
<script>
    import lang from "@/views/modules/UserRoles/language/en";
    export default {
        name: 'audit-log',
        data() {
            return {
                lang: [],
            }
        },
        mounted() {
            this.lang = lang;
        },
        methods: {

        }
    }
</script>